<div
    [class.dark-theme]="toggleService.isDark()"
>

    <!-- Sidebar -->
    <app-sidebar></app-sidebar>

    <!-- Main Content -->
    <div
        class="main-content transition d-flex flex-column"
        [ngClass]="{'active': isToggled}"
    >
        <app-header></app-header>
        <div (click)="closeSideBar()">
            <router-outlet></router-outlet>
        </div>
        <div class="flex-grow-1"></div>
    </div>

</div>
